import { Container, Heading, Box, Center } from '@chakra-ui/layout';
import React from 'react';
import { FaceSvg } from '../components/faceSVG';
import Typical from 'react-typical';
import { Link, useColorMode, useToast, useClipboard } from '@chakra-ui/react';
import { motion, useTransform, useViewportScroll } from 'framer-motion';

const MotionContainer = motion(Container);

const greetings = [
  'Halo !',
  4000,
  'こんにちは !',
  4000,
  'Bonjour !',
  4000,
  'Hi !',
  4000,
  'नमस्ते',
  4000,
  '你好 !',
  4000,
  'Hola !',
  4000,
  'ٱلسَّلَامُ عَلَيْكُمْ',
  4000,
];

const email = 'reinaldo.bbu20@gmail.com';

const About = ({ focused }) => {
  const { colorMode } = useColorMode();
  const { onCopy } = useClipboard(email);
  const toast = useToast();

  const { scrollY } = useViewportScroll();

  const y = useTransform(scrollY, [0, 400], [0, 200]);

  return (
    <MotionContainer
      maxW={{
        base: 'container.sm',
        md: 'container.md',
        lg: 'container.lg',
        xl: 'container.xl',
      }}
      transition="linear .1s"
      pb={8}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="face-svg"
        style={{
          display: 'flex',
          position: 'relative',
          justifyContent: 'center',
          marginTop: '30px',
          marginBottom: '20px',
        }}
      >
        <FaceSvg y={y} />
      </motion.div>

      <Box
        className="about-content"
        p={6}
        position="relative"
        transition="linear 0.1s"
        borderRadius="2xl"
        border="4px"
        borderColor={focused ? 'blue.200' : 'transparent'}
        backgroundColor={colorMode === 'light' ? 'white' : '#1A202C'}
      >
        <Box textAlign="center" mt={12} mb={12}>
          <Heading as="h1" size="2xl">
            <Typical steps={greetings} loop={Infinity} />
          </Heading>
        </Box>
        <Heading as="h1" lineHeight={1.4}>
          My name is{' '}
          <Link
            color="orange.500"
            href="https://www.linkedin.com/in/reinaldo-usadani/"
            isExternal
          >
            Reinaldo Usadani
          </Link>
          . And I'm a developer from Jakarta, Indonesia. I graduated from{' '}
          <Link color="orange.500" href="http://www.unklab.ac.id/" isExternal>
            Universitas Klabat, Sulawesi Utara
          </Link>{' '}
          on March 2021. After 3 and a half years of studying hard at my
          university, I ends up learning more new stuff every day by myself 😂.
          <br />
          <br />
          Currently, I'm teaching myself to learn more about{' '}
          <Link
            color="orange.500"
            href="https://en.wikipedia.org/wiki/Microservices"
            isExternal
          >
            Microservices Architecture
          </Link>{' '}
          and how to create cool apps using{' '}
          <Link
            color="orange.500"
            href="https://firebase.google.com/"
            isExternal
          >
            Firebase
          </Link>
          ,{' '}
          <Link color="orange.500" href="https://www.mongodb.com/" isExternal>
            MongoDB
          </Link>
          ,{' '}
          <Link color="orange.500" href="https://expressjs.com/" isExternal>
            ExpressJS
          </Link>
          ,{' '}
          <Link color="orange.500" href="https://reactjs.org/" isExternal>
            ReactJS
          </Link>
          , and{' '}
          <Link color="orange.500" href="https://nodejs.org/en/" isExternal>
            NodeJS
          </Link>
          . I also learn{' '}
          <Link color="orange.500" href="https://reactnative.dev/" isExternal>
            React-Native
          </Link>{' '}
          for Mobile Development and I'm loving it so far. Nevertheless, I am
          willing and enthusiastic to explore and learn new technologies. And I
          always try to improve my broken English each day!
          <br />
          <br />
          You want to get in touch? Find me here:
          <br />
          <Link
            color="orange.500"
            href="https://github.com/reinaldousadani"
            isExternal
          >
            github
          </Link>
          ,{' '}
          <Link
            color="orange.500"
            href="https://www.linkedin.com/in/reinaldo-usadani/"
            isExternal
          >
            linkedin
          </Link>
          ,{' '}
          <Link
            color="orange.500"
            href="https://www.instagram.com/reinaldo.bayu.b/"
            isExternal
          >
            instagram
          </Link>
          ,{' '}
          <Link
            color="orange.500"
            onClick={() => {
              onCopy();
              toast({
                title: 'Copied to Clipboard',
                duration: 4000,
                status: 'info',
                isClosable: true,
                position: 'top',
              });
            }}
          >
            {`${email}`}
          </Link>
          <br />
          <br />
          And here is my resume for more details!
          <br />
          <Link
            color="orange.500"
            href="https://drive.google.com/file/d/1-mlFlYL5FheolisN8vvnTDiDinbtRwdZ/view?usp=sharing"
            isExternal
          >
            resume
          </Link>
        </Heading>
        <Center mt={2} mb={4}>
          <Heading>🍻</Heading>
        </Center>
      </Box>
    </MotionContainer>
  );
};

export default About;
